"use client";

import { usePathname } from "next/navigation";
import { bookingUrlFor } from "@/lib/booking";

/**
 * Mobile sticky booking bar, restyled to the July 2026 brief: oat field
 * with a gold top hairline, ink text, and the standard ink-fill primary
 * pill (Fraunces label via .silk-pill). No gold button fields, no 4px
 * radii, no charcoal/champagne legacy language.
 *
 * Client component: the booking target is route-aware (lib/booking.ts), so
 * /auckland is not handed the Christchurch venue while the two-venue
 * question is open.
 */
export function BookingCTA() {
  const pathname = usePathname();
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden bg-oat border-t silk-hairline safe-area-bottom">
      <div className="flex items-center justify-between px-5 py-3 gap-4">
        <div className="min-w-0">
          <p className="text-ink text-sm font-medium truncate">Ready to book?</p>
          <p className="text-ink/60 text-xs truncate">
            Booked through Fresha, deposit applies
          </p>
        </div>
        <a
          href={bookingUrlFor(pathname)}
          target="_blank"
          rel="noopener noreferrer"
          className="silk-pill silk-pill--primary flex-shrink-0 !px-6 !py-2.5 text-sm"
        >
          Book Now
        </a>
      </div>
    </div>
  );
}
